// extracted by mini-css-extract-plugin
module.exports = {"blockCompanion":"index-shimmer_blockCompanion__3ubXc","placeholderShimmer":"index-shimmer_placeholderShimmer__3Cm7L"};